import type { Requests } from "../common/request.common";
import type { HotspotSessionResponseTypes } from "../common/response.common";
import { post } from "./common";

export const hotspotSession = {
    record(voucherId: string) {
        return (data: typeof Requests.HotspotSession.Record.Input) => {
            return post<typeof data, HotspotSessionResponseTypes.Record>(
                `/hotspot-session/record/${voucherId}`,
                data,
            );
        };
    },
};
